import { render, staticRenderFns } from "./FileAttachment.vue?vue&type=template&id=3d2fa87c&"
import script from "./FileAttachment.vue?vue&type=script&lang=js&"
export * from "./FileAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2fa87c')) {
      api.createRecord('3d2fa87c', component.options)
    } else {
      api.reload('3d2fa87c', component.options)
    }
    module.hot.accept("./FileAttachment.vue?vue&type=template&id=3d2fa87c&", function () {
      api.rerender('3d2fa87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/files/FileAttachment.vue"
export default component.exports